module.exports = "/_next/static/files/476f1455e2af66cec6a1864835109ef2.jpg";